document.addEventListener('DOMContentLoaded', () => {
  const sticky = document.querySelector('[data-sticky-cta]');
  const sections = document.querySelectorAll('[data-product-section]');

  if (!sticky || !sections.length) return;

  const img = document.getElementById('sticky-cta-image');
  const name = document.getElementById('sticky-cta-name');
  const tagline = document.getElementById('sticky-cta-tagline');
  const button = document.getElementById('sticky-cta-button');

  let activeSection = sections[0];
  let hasPassedViewport = false;

  // 🔒 FORCE HIDDEN ON LOAD
  sticky.classList.remove('is-visible');
  sticky.setAttribute('aria-hidden', 'true');

  // -------------------------
  // HELPERS
  // -------------------------
  function sectionHasFlavors(section) {
    return section?.dataset?.hasFlavors === 'true';
  }

  function updateStickyVisibility() {
    hasPassedViewport = window.scrollY >= window.innerHeight;

    if (!hasPassedViewport) {
      hideSticky();
      return;
    }

    if (!sectionHasFlavors(activeSection)) {
      hideSticky();
      return;
    }

    showSticky();
  }

  function showSticky() {
    sticky.classList.add('is-visible');
    sticky.setAttribute('aria-hidden', 'false');
  }

  function hideSticky() {
    sticky.classList.remove('is-visible');
    sticky.setAttribute('aria-hidden', 'true');
  }

  function hydrate(section) {
    img.src = section.dataset.productImage;
    name.textContent = section.dataset.productName;
    tagline.textContent = section.dataset.productTagline;
    button.textContent = section.dataset.ctaText;
  }

  // -------------------------
  // INITIAL HYDRATION (CONTENT ONLY)
  // -------------------------
  hydrate(activeSection);

  // -------------------------
  // OBSERVE PRODUCT SECTIONS
  // -------------------------
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        activeSection = entry.target;
        hydrate(activeSection);
        updateStickyVisibility();
      });
    },
    { threshold: 0.1 }
  );

  sections.forEach(section => observer.observe(section));

  // -------------------------
  // SCROLL HANDLER
  // -------------------------
  window.addEventListener('scroll', updateStickyVisibility, { passive: true });

  // -------------------------
  // CTA CLICK → SCROLL TO VARIANTS
  // -------------------------
  button.addEventListener('click', () => {
    if (!activeSection) return;

    activeSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});
